import type { ResultOf } from '@horof/shared';
import { graphql } from './gql';

/** The month close on the desk (docs/changes/43). */

export const MonthCloseDocument = graphql(`
  query DeskMonthClose($start: Date!, $end: Date!, $month: String!) {
    meters(
      filter: { meterStatus: { equalTo: CONNECTED } }
      orderBy: [SORT_ORDER_ASC, METER_NO_ASC]
    ) {
      nodes {
        id
        label
        member {
          id
          fullName
        }
        monthBills: bills(
          filter: {
            billMonth: { greaterThanOrEqualTo: $start, lessThanOrEqualTo: $end }
          }
          orderBy: [CREATED_AT_ASC]
        ) {
          nodes {
            id
            currentReading
            billTotal
            paidAmount
            createdAt
          }
        }
      }
    }
    report: monthlyReport(filter: { month: { equalTo: $start } }) {
      nodes {
        billsCount
        billedTotal
        consumption
      }
    }
    bills(
      filter: {
        billMonth: { greaterThanOrEqualTo: $start, lessThanOrEqualTo: $end }
      }
      orderBy: [CREATED_AT_ASC]
    ) {
      nodes {
        id
        previousReading
        currentReading
        consumption
        billTotal
        paidAmount
        billStatus
        readingPhoto {
          id
          url
        }
        member {
          id
          fullName
        }
        meter {
          id
          label
          sortOrder
        }
      }
    }
    billsLink: monthlyBillsLink(month: $month)
    receiptsLink: monthlyReceiptsLink(month: $month)
    unreachableNoticesLink: noticesLink(onlyUnreachable: true)
    allNoticesLink: noticesLink
    bulletinLink(month: $month)
  }
`);

export type CloseData = ResultOf<typeof MonthCloseDocument>;
export type MonthBillRow = NonNullable<
  NonNullable<CloseData['bills']>['nodes'][number]
>;

export const MonthWhatsappDocument = graphql(`
  query DeskMonthWhatsapp($start: Date!, $end: Date!) {
    whatsappMessages(
      filter: {
        bill: {
          billMonth: { greaterThanOrEqualTo: $start, lessThanOrEqualTo: $end }
        }
      }
      orderBy: [CREATED_AT_DESC]
    ) {
      nodes {
        id
        status
        error
        createdAt
        billId
        toPhone
        member {
          fullName
        }
      }
    }
  }
`);

export const SendMonthInvoicesDocument = graphql(`
  mutation DeskSendMonthInvoices($month: Date!) {
    appSendMonthInvoices(input: { month: $month }) {
      result {
        queued
        alreadySent
        noWhatsapp
        paid
      }
    }
  }
`);

export const ResendInvoiceDocument = graphql(`
  mutation DeskResendInvoice($billId: UUID!) {
    appSendInvoiceWhatsapp(input: { billId: $billId }) {
      result {
        id
        status
      }
    }
  }
`);

export const DeleteBillDocument = graphql(`
  mutation DeskDeleteDuplicateBill($id: UUID!) {
    deleteBill(input: { id: $id }) {
      bill {
        id
      }
    }
  }
`);

export const LatePayersDocument = graphql(`
  query DeskLatePayers($audience: LateListAudience!) {
    latePayersImages(audience: $audience)
  }
`);

export const closeContext = {
  additionalTypenames: ['Bill', 'WhatsappMessage', 'Meter', 'Payment'],
};
